import { useTranslation } from 'react-i18next';

import { Card, CardContent, ExternalLink } from '@app/shared/ui/atoms/Common';

interface CuratorInfoProps {
  telegramName?: string | null;
  name?: string | null;
}

export function CuratorInfo({ telegramName, name }: CuratorInfoProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="p-4 text-sm text-foreground">
        <div className="font-semibold uppercase tracking-wide">{t('common.curator')}</div>
        <div className="mt-2 grid grid-cols-[80px_1fr] items-center gap-2">
          <span>Telegram:</span>
          {telegramName && (
            <ExternalLink url={`t.me/${telegramName}`} className="font-medium text-accent">
              {telegramName}
            </ExternalLink>
          )}
          <span>{t('common.name')}:</span>
          {name && <span className="wrap-break-word font-medium text-foreground">{name}</span>}
        </div>
      </CardContent>
    </Card>
  );
}
